export const countries = [
  { name: "Sweden", phone: "+46", code:"SE", flag_code: 135},
  { name: "Germany", phone: "+49", code:"DE", flag_code: 122},
  { name: "Denmark", phone: "+45", code:"DK", flag_code: 151},
  { name: "Norway", phone: "+47", code:"NO", flag_code: 123},
  { name: "Finland", phone: "+358", code:"FI", flag_code: 295},
  { name: "Switzerland", phone: "+41", code:"CH", flag_code: 332},
  { name: "Austria", phone: "+43", code:"AT", flag_code: 205},
  { name: 'Afgahnistan', code: 'AF', phone: "+93", flag_code: 249 },
  { name: "Albania", phone: "+355", code:"AL", flag_code: 353},
  { name: "Algeria", phone: "+213", code:"DZ", flag_code: 148},
  { name: "American Samoa", phone: "+1", code:"AS", flag_code: 303},
  { name: "Andorra", phone: "+376", code:"AD", flag_code: 199},
  { name: "Angola", phone: "+244", code:"AO", flag_code: 203},
  { name: "Anguilla", phone: "+1", code:"AI", flag_code: 226},
  { name: "Antarctica", phone: "+672", code:"AQ", flag_code: 399},
  { name: "Antigua and Barbuda", phone: "+1", code:"AG", flag_code: 206},
  { name: "Argentina", phone: "+54", code:"AR", flag_code: 351},
  { name: "Armenia", phone: "+374", code:"AM", flag_code: 297},
  { name: "Aruba", phone: "+297", code:"AW", flag_code: 357},
  { name: "Australia", phone: "+61", code:"AU", flag_code: 119},
  { name: "Azerbaijan", phone: "+994", code:"AZ", flag_code: 231},
  { name: "Bahamas", phone: "+1", code:"BS", flag_code: 216},
  { name: "Bahrain", phone: "+973", code:"BH", flag_code: 229},
  { name: "Bangladesh", phone: "+880", code:"BD", flag_code: 277},
  { name: "Barbados", phone: "+1", code:"BB", flag_code: 248},
  { name: "Belarus", phone: "+375", code:"BY", flag_code: 262},
  { name: "Belgium", phone: "+32", code:"BE", flag_code: 204},
  { name: "Belize", phone: "+501", code:"BZ", flag_code: 237},
  { name: "Benin", phone: "+229", code:"BJ", flag_code: 284},
  { name: "Bermuda", phone: "+1", code:"BM", flag_code: 358},
  { name: "Bhutan", phone: "+975", code:"BT", flag_code: 341},
  { name: "Bolivia", phone: "+591", code:"BO", flag_code: 209},
  { name: "Bonaire, Sint Eustatius and Saba", phone: "+599", code:"BQ", flag_code: 131},
  { name: "Bosnia and Herzegovina", phone: "+387", code:"BA", flag_code: 258},
  { name: "Botswana", phone: "+267", code:"BW", flag_code: 233},
  { name: "Bouvet Island", phone: "+47", code:"BV", flag_code: 123},
  { name: "Brazil", phone: "+55", code:"BR", flag_code: 125},
  { name: "British Indian Ocean Territory", phone: "+246", code:"IO", flag_code: 359},
  { name: "British Virgin Islands", phone: "+1", code:"VG", flag_code: 294},
  { name: "Brunei", phone: "+673", code:"BN", flag_code: 271},
  { name: "Bulgaria", phone: "+359", code:"BG", flag_code: 259},
  { name: "Burkina Faso", phone: "+226", code:"BF", flag_code: 213},
  { name: "Burundi", phone: "+257", code:"BI", flag_code: 251},
  { name: "Cambodia", phone: "+855", code:"KH", flag_code: 234},
  { name: "Cameroon", phone: "+237", code:"CM", flag_code: 246},
  { name: "Canada", phone: "+1", code:"CA", flag_code: 143},
  { name: "Cape Verde", phone: "+238", code:"CV", flag_code: 270},
  { name: "Cayman Islands", phone: "+1", code:"KY", flag_code: 360},
  { name: "Central African Republic", phone: "+236", code:"CF", flag_code: 186},
  { name: "Chad", phone: "+235", code:"TD", flag_code: 130},
  { name: "Chile", phone: "+56", code:"CL", flag_code: 201},
  { name: "China", phone: "+86", code:"CN", flag_code: 126},
  { name: "Christmas Island", phone: "+61", code:"CX", flag_code: 356},
  { name: "Cocos Islands", phone: "+61", code:"CC", flag_code: 361},
  { name: "Colombia", phone: "+57", code:"CO", flag_code: 168},
  { name: "Comoros", phone: "+269", code:"KM", flag_code: 189},
  { name: "Cook Islands", phone: "+682", code:"CK", flag_code: 188},
  { name: "Costa Rica", phone: "+506", code:"CR", flag_code: 230},
  { name: "Croatia", phone: "+385", code:"HR", flag_code: 271},
  { name: "Cuba", phone: "+53", code:"CU", flag_code: 223},
  { name: "Curacao", phone: "+599", code:"CW", flag_code: 362},
  { name: "Cyprus", phone: "+357", code:"CY", flag_code: 193},
  { name: "Czech Republic", phone: "+420", code:"CZ", flag_code: 128},
  { name: "Democratic Republic of the Congo", phone: "+243", code:"CD", flag_code: 363},
  { name: "Djibouti", phone: "+253", code:"DJ", flag_code: 187},
  { name: "Dominica", phone: "+1", code:"DM", flag_code: 287},
  { name: "Dominican Republic", phone: "+1", code:"DO", flag_code: 228},
  { name: "East Timor", phone: "+670", code:"TL", flag_code: 364},
  { name: "Ecuador", phone: "+593", code:"EC", flag_code: 219},
  { name: "Egypt", phone: "+20", code:"EG", flag_code: 146},
  { name: "El Salvador", phone: "+503", code:"SV", flag_code: 183},
  { name: "Equatorial Guinea", phone: "+240", code:"GQ", flag_code: 264},
  { name: "Eritrea", phone: "+291", code:"ER", flag_code: 214},
  { name: "Estonia", phone: "+372", code:"EE", flag_code: 320},
  { name: "Ethiopia", phone: "+251", code:"ET", flag_code: 163},
  { name: "Falkland Islands", phone: "+500", code:"FK", flag_code: 365},
  { name: "Faroe Islands", phone: "+298", code:"FO", flag_code: 298},
  { name: "Fiji", phone: "+679", code:"FJ", flag_code: 330},
  { name: "France", phone: "+33", code:"FR", flag_code: 299},
  { name: "French Guiana", phone: "+594", code:"GF", flag_code: 401},
  { name: "French Polynesia", phone: "+689", code:"PF", flag_code: 144},
  { name: "French Southern and Antarctic Lands", phone: "+262", code:"TF", flag_code: 402 },
  { name: "Gabon", phone: "+241", code:"GA", flag_code: 191},
  { name: "Gambia", phone: "+220", code:"GM", flag_code: 250},
  { name: "Georgia", phone: "+995", code:"GE", flag_code: 269},
  { name: "Ghana", phone: "+233", code:"GH", flag_code: 167},
  { name: "Gibraltar", phone: "+350", code:"GI", flag_code: 309},
  { name: "Greece", phone: "+30", code:"GR", flag_code: 179},
  { name: "Greenland", phone: "+299", code:"GL", flag_code: 178},
  { name: "Grenada", phone: "+1", code:"GD", flag_code: 285},
  { name: "Guadeloupe", phone: "+590", code:"gp", flag_code: 400},
  { name: "Guam", phone: "+1", code:"GU", flag_code: 310},
  { name: "Guatemala", phone: "+502", code:"GT", flag_code: 159},
  { name: "Guernsey", phone: "+44", code:"GG", flag_code: 398},
  { name: "Guinea", phone: "+224", code:"GN", flag_code: 252},
  { name: "Guinea-Bissau", phone: "+245", code:"GW", flag_code: 261},
  { name: "Guyana", phone: "+592", code:"GY", flag_code: 182},
  { name: "Haiti", phone: "+509", code:"HT", flag_code: 366},
  { name: "Honduras", phone: "+504", code:"HN", flag_code: 183},
  { name: "Hong Kong", phone: "+852", code:"HK", flag_code: 313},
  { name: "Hungary", phone: "+36", code:"HU", flag_code: 268},
  { name: "Iceland", phone: "+354", code:"IS", flag_code: 139},
  { name: "India", phone: "+91", code:"IN", flag_code: 180},
  { name: "Indonesia", phone: "+62", code:"ID", flag_code: 329},
  { name: "Iran", phone: "+98", code:"IR", flag_code: 161},
  { name: "Iraq", phone: "+964", code:"IQ", flag_code: 124},
  { name: "Ireland", phone: "+353", code:"IE", flag_code: 254},
  { name: "Isle of Man", phone: "+44", code:"IM", flag_code: 367},
  { name: "Israel", phone: "+972", code:"IL", flag_code: 243},
  { name: "Italy", phone: "+39", code:"IT", flag_code: 140},
  { name: "Ivory Coast", phone: "+225", code:"CI", flag_code: 162},
  { name: "Jamaica", phone: "+1", code:"JM", flag_code: 321},
  { name: "Japan", phone: "+81", code:"JP", flag_code: 137},
  { name: "Jersey", phone: "+44", code:"JE", flag_code: 368},
  { name: "Jordan", phone: "+962", code:"JO", flag_code: 172},
  { name: "Kazakhstan", phone: "+7", code:"KZ", flag_code: 194},
  { name: "Kenya", phone: "+254", code:"KE", flag_code: 218},
  { name: "Kiribati", phone: "+686", code:"KI", flag_code: 150},
  { name: "Kosovo", phone: "+383", code:"XK", flag_code: 369},
  { name: "Kuwait", phone: "+965", code:"KW", flag_code: 323},
  { name: "Kyrgyzstan", phone: "+996", code:"KG", flag_code: 301},
  { name: "Laos", phone: "+856", code:"LA", flag_code: 208},
  { name: "Latvia", phone: "+371", code:"LV", flag_code: 205},
  { name: "Lebanon", phone: "+961", code:"LB", flag_code: 244},
  { name: "Lesotho", phone: "+266", code:"LS", flag_code: 370},
  { name: "Liberia", phone: "+231", code:"LR", flag_code: 275},
  { name: "Libya", phone: "+218", code:"LY", flag_code: 372},
  { name: "Liechtenstein", phone: "+423", code:"LI", flag_code: 279},
  { name: "Lithuania", phone: "+370", code:"LT", flag_code: 314},
  { name: "Luxembourg", phone: "+352", code:"LU", flag_code: 131},
  { name: "Macao", phone: "+853", code:"MO", flag_code: 371},
  { name: "Macedonia", phone: "+389", code:"MK", flag_code: 340},
  { name: "Madagascar", phone: "+261", code:"MG", flag_code: 184},
  { name: "Malawi", phone: "+265", code:"MW", flag_code: 255},
  { name: "Malaysia", phone: "+60", code:"MY", flag_code: 207},
  { name: "Maldives", phone: "+960", code:"MV", flag_code: 306},
  { name: "Mali", phone: "+223", code:"ML", flag_code: 253},
  { name: "Malta", phone: "+356", code:"MT", flag_code: 312},
  { name: "Marshall Islands", phone: "+692", code:"MH", flag_code: 185},
  { name: "Martinique", phone: "", code:"MQ", flag_code: 405},
  { name: "Mauritania", phone: "+222", code:"MR", flag_code: 175},
  { name: "Mauritius", phone: "+230", code:"MU", flag_code: 335},
  { name: "Mayotte", phone: "+262", code:"YT", flag_code: 373},
  { name: "Mexico", phone: "+52", code:"MX", flag_code: 166},
  { name: "Micronesia", phone: "+691", code:"FM", flag_code: 322},
  { name: "Moldova", phone: "+373", code:"MD", flag_code: 278},
  { name: "Monaco", phone: "+377", code:"MC", flag_code: 133},
  { name: "Mongolia", phone: "+976", code:"MN", flag_code: 374},
  { name: "Montenegro", phone: "+382", code:"ME", flag_code: 375},
  { name: "Montserrat", phone: "+1", code:"MS", flag_code: 333},
  { name: "Morocco", phone: "+212", code:"MA", flag_code: 177},
  { name: "Mozambique", phone: "+258", code:"MZ", flag_code: 200},
  { name: "Myanmar", phone: "+95", code:"MM", flag_code: 377},
  { name: "Namibia", phone: "+264", code:"NA", flag_code: 171},
  { name: "Nauru", phone: "+674", code:"NR", flag_code: 317},
  { name: "Nepal", phone: "+977", code:"NP", flag_code: 240},
  { name: "Netherlands", phone: "+31", code:"NL", flag_code: 131},
  { name: "Netherlands Antilles", phone: "+599", code:"AN", flag_code: 260},
  { name: "New Caledonia", phone: "+687", code:"NC", flag_code: 378},
  { name: "New Zealand", phone: "+64", code:"NZ", flag_code: 119},
  { name: "Nicaragua", phone: "+505", code:"NI", flag_code: 241},
  { name: "Niger", phone: "+227", code:"NE", flag_code: 190},
  { name: "Nigeria", phone: "+234", code:"NG", flag_code: 165},
  { name: "Niue", phone: "+683", code:"NU", flag_code: 318},
  { name: "Norfolk Island", phone: "+672", code: "NF", flag_code: 339},
  { name: "North Korea", phone: "+850", code:"KP", flag_code: 300},
  { name: "Northern Mariana Islands", phone: "+1", code:"MP", flag_code: 376},
  { name: "Oman", phone: "+968", code:"OM", flag_code: 274},
  { name: "Pakistan", phone: "+92", code:"PK", flag_code: 157},
  { name: "Palau", phone: "+680", code:"PW", flag_code: 348},
  { name: "Palestine", phone: "+970", code:"PS", flag_code: 379},
  { name: "Panama", phone: "+507", code:"PA", flag_code: 170},
  { name: "Papua New Guinea", phone: "+675", code:"PG", flag_code: 121},
  { name: "Paraguay", phone: "+595", code:"PY", flag_code: 181},
  { name: "Peru", phone: "+51", code:"PE", flag_code: 196},
  { name: "Philippines", phone: "+63", code:"PH", flag_code: 156},
  { name: "Pitcairn", phone: "+64", code:"PN", flag_code: 380},
  { name: "Poland", phone: "+48", code:"PL", flag_code: 276},
  { name: "Portugal", phone: "+351", code:"PT", flag_code: 247},
  { name: "Puerto Rico", phone: "+1", code:"PR", flag_code: 211},
  { name: "Qatar", phone: "+974", code:"QA", flag_code: 290},
  { name: "Republic of the Congo", phone: "+242", code:"CG", flag_code: 202},
  { name: "Reunion", phone: "+262", code:"RE", flag_code: 383},
  { name: "Romania", phone: "+40", code:"RO", flag_code: 130},
  { name: "Russia", phone: "+7", code:"RU", flag_code: 136},
  { name: "Rwanda", phone: "+250", code:"RW", flag_code: 266},
  { name: "Saint Barthelemy", phone: "+590", code:"BL", flag_code: 381},
  { name: "Saint Helena", phone: "+290", code:"SH", flag_code: 382},
  { name: "Saint Kitts and Nevis", phone: "+1", code:"KN", flag_code: 338},
  { name: "Saint Lucia", phone: "+1", code:"LC", flag_code: 352},
  { name: "Saint Martin", phone: "+590", code:"MF", flag_code: 384},
  { name: "Saint Pierre and Miquelon", phone: "+508", code:"PM", flag_code: 385},
  { name: "Saint Vincent and the Grenadines", phone: "+1", code:"VC", flag_code: 386},
  { name: "Samoa", phone: "+685", code:"WS", flag_code: 387},
  { name: "San Marino", phone: "+378", code:"SM", flag_code: 388},
  { name: "Sao Tome and Principe", phone: "+239", code:"ST", flag_code: 342},
  { name: "Saudi Arabia", phone: "+966", code:"SA", flag_code: 164},
  { name: "Senegal", phone: "+221", code:"SN", flag_code: 273},
  { name: "Serbia", phone: "+381", code:"RS", flag_code: 389},
  { name: "Seychelles", phone: "+248", code:"SC", flag_code: 239},
  { name: "Sierra Leone", phone: "+232", code:"SL", flag_code: 265},
  { name: "Singapore", phone: "+65", code:"SG", flag_code: 346},
  { name: "Sint Maarten", phone: "+1", code:"SX", flag_code: 390},
  { name: "Slovakia", phone: "+421", code:"SK", flag_code: 267},
  { name: "Slovenia", phone: "+386", code:"SI", flag_code: 326},
  { name: "Solomon Islands", phone: "+677", code:"SB", flag_code: 176},
  { name: "Somalia", phone: "+252", code:"SO", flag_code: 198},
  { name: "South Africa", phone: "+27", code:"ZA", flag_code: 152},
  { name: "South Georgia and the South Sandwich Islands", phone: "+500", code:"GS", flag_code: 404},
  { name: "South Korea", phone: "+82", code:"KR", flag_code: 141},
  { name: "South Sudan", phone: "+211", code:"SS", flag_code: 391},
  { name: "Spain", phone: "+34", code:"ES", flag_code: 343},
  { name: "Sri Lanka", phone: "+94", code:"LK", flag_code: 173},
  { name: "Sudan", phone: "+249", code:"SD", flag_code: 147},
  { name: "Suriname", phone: "+597", code:"SR", flag_code: 149},
  { name: "Svalbard and Jan Mayen", phone: "+47", code:"SJ", flag_code: 123},
  { name: "Swaziland", phone: "+268", code:"SZ", flag_code: 393},
  { name: "Syria", phone: "+963", code:"SY", flag_code: 197},
  { name: "Taiwan", phone: "+886", code:"TW", flag_code: 283},
  { name: "Tajikistan", phone: "+992", code:"TJ", flag_code: 161},
  { name: "Tanzania", phone: "+255", code:"TZ", flag_code: 212},
  { name: "Thailand", phone: "+66", code:"TH", flag_code: 127},
  { name: "Togo", phone: "+228", code:"TG", flag_code: 325},
  { name: "Tokelau", phone: "+690", code:"TK", flag_code: 392},
  { name: "Tonga", phone: "+676", code:"TO", flag_code: 296},
  { name: "Trinidad and Tobago", phone: "+1", code:"TT", flag_code: 344},
  { name: "Tunisia", phone: "+216", code:"TN", flag_code: 289},
  { name: "Turkey", phone: "+90", code:"TR", flag_code: 132},
  { name: "Turkmenistan", phone: "+993", code:"TM", flag_code: 215},
  { name: "Turks and Caicos Islands", phone: "+1", code:"TC", flag_code: 394},
  { name: "Tuvalu", phone: "+688", code:"TV", flag_code: 304},
  { name: 'United States', code: 'US', phone: "+1", flag_code: 120 },
  { name: "U.S. Virgin Islands", phone: "+1", code:"VI", flag_code: 395},
  { name: "Uganda", phone: "+256", code:"UG", flag_code: 293},
  { name: "Ukraine", phone: "+380", code:"UA", flag_code: 282},
  { name: "United Arab Emirates", phone: "+971", code:"AE", flag_code: 153},
  { name: "United Kingdom", phone: "+44", code:"GB", flag_code: 134},
  { name: "Uruguay", phone: "+598", code:"UY", flag_code: 220},
  { name: "Uzbekistan", phone: "+998", code:"UZ", flag_code: 227},
  { name: "Vanuatu", phone: "+678", code:"VU", flag_code: 222},
  { name: "Vatican", phone: "+379", code:"VA", flag_code: 396},
  { name: "Venezuela", phone: "+58", code:"VE", flag_code: 154},
  { name: "Vietnam", phone: "+84", code:"VN", flag_code: 256},
  { name: "Wallis and Futuna", phone: "+681", code:"WF", flag_code: 355},
  { name: "Western Sahara", phone: "+212", code:"EH", flag_code: 397},
  { name: "Yemen", phone: "+967", code:"YE", flag_code: 158},
  { name: "Zambia", phone: "+260", code:"ZM", flag_code: 236},
  { name: "Zimbabwe", phone: "+263", code:"ZW", flag_code: 245},
  { name: "Åland Islands", phone: "+358", code:"AX", flag_code: 403} 
]
